import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/**
 * The scrollable region of a list page. It bleeds to the pane edges (cancelling
 * the page padding) and is the only thing that scrolls, so toolbars and
 * pagination stay put. On mobile it spans the full viewport width.
 */
export function ScrollArea({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <div
      className={cn(
        '-ml-6 min-h-0 w-[calc(100%+3rem)] flex-1 overflow-y-auto px-6 max-sm:w-screen max-sm:px-3',
        className,
      )}
    >
      {children}
    </div>
  );
}

/**
 * Pagination footer for list pages. Lives inside the `ScrollArea` so it sits
 * right after the list when everything fits, but sticks to the bottom of the
 * pane once the list overflows.
 */
export function ListPagination({ children }: { children: ReactNode }) {
  return (
    <div className="sticky bottom-0 z-10 mt-4 flex flex-wrap items-center justify-between gap-3 bg-muted/30 pt-3 backdrop-blur-sm">
      {children}
    </div>
  );
}
